// ============================================================================
// CANCELLATION ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Cancellation';

export const cancellationEndpoints = {
  /** POST /api/v1/Cancellation/{bookingId} — cancels a booking. */
  cancel: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:bookingId`, { bookingId }),
  /** GET /api/v1/Cancellation/by-booking/{bookingId} — reads the active cancellation record. */
  getByBooking: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-booking/:bookingId`, { bookingId }),
} as const;

export default cancellationEndpoints;
